// NodeViewService.js

/**
 * NodeViewService.js
 *
 * Central place for Firestore view logging.
 */

// Firebase
import { addDoc, collection } from 'firebase/firestore';
import { db, collections } from 'firebaseConfig';

// Services
import { nowTimestamp } from 'services/nodes/NodeWriteService';

// Utility to check for non-empty string
const isNonEmptyString = (value) => typeof value === 'string' && value.trim().length > 0;

/**
 * Records a view event for a given node.
 * 
 * @param {Object} params - Parameters for recording the view.
 * @param {string} params.nodeKey - The key of the node being viewed.
 * @param {string} [params.userKey] - The key of the user viewing the node (optional).
 * @param {Object} [params.user] - Additional user info object (optional).
 * 
 * @returns {Promise<void>} - Resolves when the view is recorded.
 */
export async function recordNodeView({ nodeKey, userKey = null, user = null }) {

	// Validate input
	if (!isNonEmptyString(nodeKey)) return;

	// Prepare payload
	const payload = {
		nodeKey,
		timestamp: nowTimestamp(),
	};

	// Include userKey if provided
	if (isNonEmptyString(userKey)) {
		payload.userKey = userKey;
	}

	// Include user object if provided
	if (user && typeof user === 'object') {
		payload.user = user;
	}

	// Save view record to Firestore
	await addDoc(collection(db, collections.nodeviews), payload);
}
